export const riskidentification = {
  methods: {
    //查询全部风险类型
    async getRiskTypeall(obj) {
      let { pageNum, pageSize, name } = obj;
      //分页
      let res = await this.$http.get("/tenant/risk/type/list", {
        name: name ?? null,
        pageNum,
        pageSize,
      });
      return res || [];
    },
    //TODO: 获取二十大类风险类型
    async getregularRiskType() {
      let res = await this.$http.get("/tenant/risk/type/regular/list");
      return res.data;
    },
    async getRiskTypeList() {
      let res = await this.$http.get("/tenant/risk/type/list");
      return res.rows || [];
    },
    //获取风险评估详情
    async getRiskTypeDetail(id) {
      let res = await this.$http.get(`/tenant/risk/idetion/${id}`);
      console.log(res);
      return res.data;
    },
    //手动汇总
    async postCollectHand(arr) {
      let res = await this.$http.post("/tenant/risk/collect/hand", {
        idList: arr
      });
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res.rows || [];
    },
    //新增风险类型
    async addRiskType(obj) {
      let res = await this.$http.post("/tenant/risk/type", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
    },
    //修改风险识别类型
    async upRiskType(obj) {
      let res = await this.$http.put("/tenant/risk/type", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
    },
    //删除风险识别类型
    async delRiskType(obj) {
      let res = await this.$http.delete(`/tenant/risk/type/${obj.id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
    },
    //获取风险类型详细
    async getRiskTypeInfo(id) {
      let res = await this.$http.get(`/tenant/risk/type/${id}`);
      return res.data;
    },
    //根据名称查询风险识别类型
    async getRiskType(val) {
      let res = await this.$http.get("/risk/getrisktypeName", {
        name: val,
      });
      return res?.data || [];
    },
    //查询全部风险等级
    async getRiskLevelList() {
      //分页
      let res = await this.$http.get("/tenant/risk/level/list");
      return res?.rows || [];
    },
    //查询全部风险等级
    async getRiskLevelall(obj) {
      let { pageNum, pageSize, level } = obj;
      let res = await this.$http.get("/tenant/risk/level/list", {
        level: level ?? null,
        pageNum,
        pageSize,
      });
      return res || [];
    },
    //新增风险等级
    async addRiskLevel(obj) {
      let res = await this.$http.post("/tenant/risk/level", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;
    },
    //修改风险等级
    async upRiskLevel(obj) {
      let res = await this.$http.put("/tenant/risk/level", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
    },
    //删除风险等级
    async delRiskLevel(obj) {
      let res = await this.$http.delete(`/tenant/risk/level/${obj.id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
    },
    //根据名称查询风险识别类型
    async getRiskLevel(val) {
      let res = await this.$http.get("/risk/getrisklevelName", {
        level: val,
      });
      return res?.data || [];
    },

    //获取所有风险录入
    async getRiskentryall() {
      //分页
      let res = await this.$http.get("/risk/getriskentryAllPages", {
        currentPage: this.tableConfig.page,
        pageSize: this.tableConfig.size,
      });
      return res?.data?.list || [];
    },
    //新增风险录入
    async addRiskentry(obj) {
      obj.no = this.$format.noid(); //格式化编号
      let res = await this.$http.post("/risk/addriskentry", obj);
      if (res.status == "0") {
        this.$message({ message: "新增成功", type: "success" });
      } else {
        this.$message.error("新增失败");
      }
      return res;
    },

    //修改风险录入
    async upRiskentry(obj) {
      let res = await this.$http.put("/risk/upriskentryId", obj);
      if (res.status == "0") {
        this.$message({ message: "修改成功", type: "success" });
      } else {
        this.$message.error("修改失败");
        return;
      }
    },
    //删除风险录入
    async delRiskentry(obj) {
      let res = await this.$http.delete("/risk/delriskentryId", obj);
      if (res.status == "0") {
        this.$message({ message: "删除成功", type: "success" });
      } else {
        this.$message.error("删除失败");
        return;
      }
    },
    //根据名称查询风险录入
    async getRiskentry(val) {
      let res = await this.$http.get("/risk/getriskentryTitle", {
        title: val,
      });
      return res?.data || [];
    },

    //获取所有风险辨识
    async getRiskidetionall(obj) {
      let { pageNum, pageSize, title } = obj;
      let res = await this.$http.get("/tenant/risk/idetion/list", {
        title: title ?? null,
        pageNum,
        pageSize,
      });
      return res || [];
    },
    //TODO：新增风险评估
    async addRiskidetion(obj, fileList) {
      obj.no = this.$format.noid(); //格式化编号
      let fileData = fileList.map((item) => item.raw);

      //TODO：先新增记录，拿到id
      let idres = await this.$http.post("/tenant/risk/idetion", obj);
      //  Object.keys(obj).forEach(keys=>{
      //   formData.append(keys, obj[keys]);
      //  })
      fileData.forEach(async (file, index) => {
        let formData = new FormData();
        formData.append("file", file);
        let res = await this.$http.post(
          `/tenant/file/risk/idetion/${idres.data}`,
          formData,
          {
            "Content-Type": "multipart/form-data",
          }
        );
        if (res.code == 200 && index == fileData.length - 1) {
          this.$message({ message: "新增成功", type: "success" });
        }
      });
    },
    //修改风险辨识
    async upRiskidetion(obj, fileList) {
      let res = await this.$http.put("/tenant/risk/idetion", obj);
      //TODO:上传图片
      if (fileList.length > 0) {
        for (let i = 0; i < fileList.length; i++) {
          let ret = await this.addidetionImages(fileList[i], obj);
        }
      }
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
        return;
      }
    },
    //删除风险辨识
    async delRiskidetion(obj) {
      let res = await this.$http.delete(`/tenant/risk/idetion/${obj.id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
        return;
      }
    },
    //根据名称查询风险辨识
    async getRiskidetion(val) {
      let res = await this.$http.get("/risk/getriskidetionTitle", {
        title: val,
      });
      return res?.data || [];
    },
    //上传风险辨识图片
    async addidetionImages(file, obj) {
      if (!file.raw) return true;
      let formData = new FormData();
      // formData.append('no', obj.no);
      // formData.append('operator', obj.operator);
      formData.append("file", file.raw);
      let res = await this.$http.post(
        `/tenant/file/risk/idetion/${obj.id}`,
        formData,
        {
          "Content-Type": "multipart/form-data",
        }
      );
    },
    //通过编号查询风险辨识图片
    async getidetionImages(obj) {
      let res = await this.$http.get("/risk/getriskidetionPhotono", {
        no: obj.no,
      });
      return res?.data || [];
    },
    //通过图片id删除图片
    async delidetionImage(file) {
      let res = await this.$http.delete(
        `/tenant/risk/idetion/remove/photo/${file.id}`
      );
      return res || [];
    },
    //TODO:审批风险辨识
    async Approval(val) {
      this.$confirm("确定要处理该风险吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let res = await this.$http.put(
            `/tenant/risk/idetion/update/alreadyHandled/${val.id}`
          );
          if (res.code == 200) {
            await this.getData(); //刷新
            this.$message({ type: "success", message: res.msg });
          }
        })
        .catch(() => { });
    },

    //TODO: 查找风险类型汇总
    async getRiskSummary(obj) {
      let { pageNum, pageSize, collectTime } = obj;
      let res = await this.$http.get("/tenant/risk/collect/list", {
        collectTime: collectTime ?? null,
        pageSize: pageSize ?? null,
        pageNum: pageNum ?? null,
      });
      return res;
    },

    //TODO: 查询风险类型汇总信息
    async getRiskSummaryById(id) {
      let res = await this.$http.get(`/tenant/risk/collect/apporve/${id}`);
      console.log(res);
      return res.data;
    },
    //TODO: 查询风险类型信息
    async getRiskSummaryById2(id) {
      let res = await this.$http.get(`/tenant/risk/type/${id}`);
      return res.data;
    },

    //TODO： 删除汇总记录
    async deleteRiskSummaryById(id) {
      let res = await this.$http.delete(`/tenant/risk/collect/${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
        return;
      }
    },
    //TODO：风险类型汇总提交审核
    async riskSumbitApprove(collectId) {
      let res = await this.$http.post(`/tenant/risk/collect/approve/${collectId}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
      }
      return res;

    },
    async saveRiskSummary(obj) {
      let res = await this.$http.put("/tenant/risk/type", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
        return;
      }
    },

    //TODO: 获取风险类型统计指标
    async getRiskSummaryTotal(obj) {
      let { pageNum, pageSize, userName } = obj;
      let res = await this.$http.get("/tenant/risk/statistics/list", {
        userName: userName ?? null,
        pageSize: pageSize ?? null,
        pageNum: pageNum ?? null,
      });
      console.log(res);

      return res;
    },
    //TODO: 获取风险类型统计指标制度
    async getRiskTotal() {
      let res = await this.$http.get("/tenant/risk/statistics/ism");

      return res;
    },

    //TODO: 获取风险区域树形数据
    async getAreaTreeData() {
      let res = await this.$http.get("/tenant/map/ground/tree");

      return res;
    },

    //TODO： 新增面
    async addAreaPros(obj) {
      let res = await this.$http.post("/tenant/map/ground", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
        return;
      }
    },
    //TODO： 修改面
    async upAreaPros(obj) {
      let res = await this.$http.put("/tenant/map/ground", obj);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
        return;
      }
    },
    //TODO： 删除面
    async delAreaPros(id) {
      console.log(id);
      let res = await this.$http.delete(`/tenant/map/ground/${id}`);
      if (res.code == 200) {
        this.$message({ message: res.msg, type: "success" });
      } else {
        this.$message.error(res.msg);
        return;
      }
    },
    //TODO： 获取风险类型
    async getRiskTypeData() {
      let res = await this.$http.get("/tenant/map/ground/risk/point");
      return res;
    },

    //TODO: 获取总部租户地图信息
     async getTenantMapData() {
      let res = await this.$http.get("/tenant/map/ground/list");
      return res;
    },
  },
};
